var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navheader borderbox",staticStyle:{"border-bottom":"none"}},[_c('img',{staticClass:"back",attrs:{"src":require("../assets/img/back-b.png")},on:{"click":function($event){return _vm.goBack()}}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }